'use client';

import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { Select, type SelectItem } from '~/app/_components/select';
import type { SeriesOverview } from '~/common/types/series-overview';
import { routes } from '~/utils/routes';
import { Box, BoxProps } from '@styled-system/jsx';

type Props = {
  currentSeriesId: string;
  series: SeriesOverview[];
} & BoxProps;

export const SeasonSelectContainer = ({
  currentSeriesId,
  series,
  ...boxProps
}: Props) => {
  const router = useRouter();

  const seasonItems: SelectItem[] = series.map((series, index) => ({
    value: series.id,
    label: `シーズン${index + 1}`,
  }));
  const defaultValue = series.find(
    (series) => series.id === currentSeriesId
  )?.id;

  const handleOnChangeSeason = useCallback(
    (item: SelectItem) => {
      router.push(routes.series.url(item.value));
    },
    [router]
  );

  return (
    <Box {...boxProps}>
      <Select
        items={seasonItems}
        defaultValue={defaultValue}
        maxW="160px"
        onSelectItem={handleOnChangeSeason}
      />
    </Box>
  );
};
